// extracted by mini-css-extract-plugin
module.exports = {"container":"MVSlot_container__s7BQ9","patreon":"MVSlot_patreon__EfEcK","slots":"MVSlot_slots__8kQkO"};